/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-progress-bar-fill::after{background-color:#5f9ea0}  .mat-progress-bar-buffer{background-color:#b0c4de}  .mat-progress-bar{border-radius:10px;height:25px!important;border:ridge}.progress-bar-section[_ngcontent-%COMP%]{display:flex;align-content:center;align-items:center;height:60px;justify-content:center}"];
export { styles as styles };
